var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-link",style:({ color: _vm.fg }),on:{"click":function($event){_vm.$emit('click')}}},[_vm._t("default",[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"button-link-underline",style:(_vm.underlineStyle)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }